import { defineStore } from 'pinia';
import { createSocket } from '@frontend/ui/features/chat/chatFunctions.js';

// It is convention to prefix store names here with "use"
export const useChatStore = defineStore('chat', {
  state: () => ({
    socket: null,
    conversations: {},
    currentConversationId: null,
    activeTabName: '',
    // Tracks in-flight tool operations so UI can show a spinner until completion
    toolActivityCount: 0,
    lastToolDescription: '',
  }),

  actions: {
    async setContext(context) {
      const conversation = this.conversations[this.currentConversationId];
      this.conversations = {
        ...this.conversations,
        [this.currentConversationId]: {
          ...conversation,
          context,
        },
      };
    },
    startToolActivity(description) {
      try {
        this.toolActivityCount = (this.toolActivityCount || 0) + 1;
        if (description) this.lastToolDescription = String(description);
      } catch (e) {
        this.toolActivityCount = 1;
        if (description) this.lastToolDescription = String(description);
      }
    },
    finishToolActivity() {
      try {
        const next = (this.toolActivityCount || 0) - 1;
        this.toolActivityCount = next > 0 ? next : 0;
        if (this.toolActivityCount === 0) this.lastToolDescription = '';
      } catch (e) {
        this.toolActivityCount = 0;
        this.lastToolDescription = '';
      }
    },
    resetToolActivity() {
      this.toolActivityCount = 0;
      this.lastToolDescription = '';
    },
    async createSocket(socketPath = '/ws/agent-chat/') {
      if (this.socket) return;
      this.socket = await createSocket(this, socketPath);
      console.log('SOCKET CREATED, SHOULD MOVE ON');
    },
    async pushMessage(message) {
      const conversation = this.conversations[this.currentConversationId];
      const newMessage = { ...message };
      const messages = [...conversation.messages, newMessage];
      // this looks complicated but it's just pushing to the messages array. Have to do it like this because of reactivity
      this.conversations = {
        ...this.conversations,
        [this.currentConversationId]: {
          ...conversation,
          messages,
        },
      };
    },
    async sendMessage(message, portfolioID, benchmarkID) {
      this.pushMessage(message);
      this.socket.send(JSON.stringify({ ...this.conversations[this.currentConversationId], activeTabName: this.activeTabName, portfolio_id: portfolioID, benchmark_id: benchmarkID }));
      console.log('THIS CONVERSATIONS', this.conversations[this.currentConversationId].messages);
      // TODO other stuff
    },
    async setStreamingMessage(message) {
      const conversation = this.conversations[this.currentConversationId];
      this.conversations = {
        ...this.conversations,
        [this.currentConversationId]: {
          ...conversation,
          streamingMessage: message,
        },
      };
    },
    async pushToStreamingMessage(message) {
      const conversation = this.conversations[this.currentConversationId];
      this.conversations = {
        ...this.conversations,
        [this.currentConversationId]: {
          ...conversation,
          streamingMessage: { text: conversation.streamingMessage.text + message.text, role: message.role },
        },
      };
    },
  },
});
